module.exports = __webpack_public_path__ + "static/media/ifas_logo.e55a1786.png";